<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Lamps`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.2002 9.99995C3.2002 5.13982 7.14007 1.19995 12.0002 1.19995C16.8603 1.19995 20.8002 5.13982 20.8002 9.99995V12.2978C20.8002 13.1274 20.1277 13.8 19.298 13.8H12.8002V20.2H16.5002C16.942 20.2 17.3002 20.5581 17.3002 21C17.3002 21.4418 16.942 21.7999 16.5002 21.7999H7.5002C7.05837 21.7999 6.7002 21.4418 6.7002 21C6.7002 20.5581 7.05837 20.2 7.5002 20.2H11.2002V13.8H8.3002V16C8.3002 16.4418 7.94202 16.8 7.5002 16.8C7.05837 16.8 6.7002 16.4418 6.7002 16V13.8H4.70233C3.87271 13.8 3.2002 13.1274 3.2002 12.2978V9.99995ZM7.50196 12.2L7.5002 12.2L7.49843 12.2H4.8002V9.99995C4.8002 6.02348 8.02372 2.79995 12.0002 2.79995C15.9767 2.79995 19.2002 6.02348 19.2002 9.99995V12.2H12.002L12.0002 12.2L11.9984 12.2H7.50196Z"/></svg>
</template>
<script>

export default {
  name: 'IconLamps',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
